var content = {}
export default content